import { Component } from '@angular/core';

@Component({
	selector: 'cmv-member-agreement-modal',
	templateUrl: './member-agreement-modal.component.html',
	styleUrls: ['./member-agreement-modal.component.scss'],
})
export class MemberAgreementModalComponent {
	isMemberModalVisible: boolean = true;
	constructor() {}

	showMemberModal(): void {
		this.isMemberModalVisible = true;
	}

	hideMemberModal(): void {
		this.isMemberModalVisible = false;
	}
}
